import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TechnicalserviceCompanyService } from '../../../services/technicalservice-company.service';

@Component({
  selector: 'app-view-technicalservice-companies',
  templateUrl: './view-technicalservice-companies.component.html',
  styleUrls: ['./view-technicalservice-companies.component.css'],
  providers:[TechnicalserviceCompanyService]
})
export class ViewTechnicalserviceCompaniesComponent implements OnInit {
  id: number = undefined;
  private sub: any;
  technicalserviceCompany: any = {
  };
  constructor(private technicalserviceCompanyService:TechnicalserviceCompanyService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      if (params['id'] !== undefined){
        this.id = params['id'];
        this.getTechnicalserviceCompany();
      }
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getTechnicalserviceCompany(){
    this.technicalserviceCompanyService.get(this.id).subscribe((technicalserviceCompany) => {
      this.technicalserviceCompany = technicalserviceCompany;
    });
  }
  

  saveTechnicalserviceCompany(){
    if (this.technicalserviceCompany.id == undefined){
      this.technicalserviceCompanyService.create(this.returnTechnicalserviceCompanyProperties(this.technicalserviceCompany))
      .subscribe((technicalserviceCompany) => {
        this.technicalserviceCompanyService.get(technicalserviceCompany.id).subscribe((technicalserviceCompany) => {
          this.technicalserviceCompany = technicalserviceCompany;
          this.router.navigate(['/configuration/technicalservicecompanies']);
        });
      });
    }else{
      this.technicalserviceCompanyService.update(this.returnTechnicalserviceCompanyProperties(this.technicalserviceCompany))
      .subscribe((technicalserviceCompany) => {
        this.technicalserviceCompany = technicalserviceCompany;
        this.router.navigate(['/configuration/technicalservicecompanies']);
      });
    }
  }

  returnTechnicalserviceCompanyProperties(technicalserviceCompany){
    var properties = {
      name: technicalserviceCompany.name,
      repairman: technicalserviceCompany.repairman,
      address: technicalserviceCompany.address,
      telephone: technicalserviceCompany.telephone
    }
    if (technicalserviceCompany.id){
      properties['id'] = technicalserviceCompany.id;
    }
    return properties;
  }

}



// WEBPACK FOOTER //
// ./src/app/configuration/components/technicalservice-companies/view-technicalservice-companies/view-technicalservice-companies.component.ts